"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@dbi-tools/ui-kit");

var _themeProvider = require("@dbi-tools/ui-kit/lib/components/theme-provider");

var _helpers = require("../../helpers");

var _themeOptions = require("../../helpers/theme-options");

var _useMedia = require("../../hooks/use-media");

var _useStyles = require("../../hooks/useStyles");

var _const = require("../../const");

var _carouselUi = _interopRequireDefault(require("../carousel/carousel-ui"));

var _headerTitles = require("../header-titles");

var _linkButtons = _interopRequireDefault(require("../link-buttons"));

var _colorCarousel = require("./color-carousel.styled");

var _const2 = require("./const");

var _style = _interopRequireDefault(require("./style"));

var _colorCircle = _interopRequireDefault(require("../color-circle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ColorCarousel = function ColorCarousel(props) {
  var _props$theme = props.theme,
      currentTheme = _props$theme === void 0 ? _themeOptions.ThemeVariants.WHITE : _props$theme,
      id = props.id,
      removeTopPadding = props.removeTopPadding,
      removeBottomPadding = props.removeBottomPadding,
      headline1 = props.headline1,
      headline2 = props.headline2,
      description = props.description,
      _props$colors = props.colors,
      colors = _props$colors === void 0 ? [] : _props$colors,
      buttons = props.buttons;

  if (!headline1 && !headline2 && !description && !colors.length) {
    return /*#__PURE__*/_react.default.createElement(_uiKit.Heading, {
      align: "center",
      as: "h2",
      fontWeight: "bold",
      measure: "h1"
    }, "Please configure COLOR CAROUSEL component");
  }

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      backDropHeight = _useState2[0],
      setBackDropHeight = _useState2[1];

  var isMobile = (0, _useMedia.useMedia)(_const.Breakpoints.MOBILE);
  var paddingSize = isMobile ? _const.MOBILE_PADDING_SIZE : _const.DEFAULT_PADDING_SIZE;
  var bottomPadding = removeBottomPadding ? 0 : paddingSize;
  var topPadding = removeTopPadding ? 0 : paddingSize;
  var containerPadding = [topPadding, 0, bottomPadding];
  var _themeStrategy$curren = _themeOptions.themeStrategy[currentTheme],
      headline1Color = _themeStrategy$curren.headline1Color,
      headline2Color = _themeStrategy$curren.headline2Color,
      type = _themeStrategy$curren.type,
      size = _themeStrategy$curren.size;
  var isDarkTheme = type === _themeOptions.ThemeType.DARK;
  var isHalfDarkTheme = size === _themeOptions.ThemeSize.HALF;
  var isInverse = isDarkTheme && !isHalfDarkTheme;
  var basicStyles = (0, _useStyles.useStyles)('a', _style.default);
  var theme = {
    $theme: currentTheme,
    $styles: basicStyles,
    $backDropHeight: backDropHeight
  };
  var containerRef = (0, _react.useRef)();
  var carouselRef = (0, _react.useRef)();

  var updateValues = function updateValues() {
    var currentContainer = containerRef.current;
    var currentCarousel = carouselRef.current;
    if (!currentContainer || !currentCarousel) return;

    var _getBoundingClientRec = currentContainer.getBoundingClientRect(),
        containerTop = _getBoundingClientRec.top;

    var _getBoundingClientRec2 = currentCarousel.getBoundingClientRect(),
        top = _getBoundingClientRec2.top;

    setBackDropHeight(Math.abs(top - containerTop + _const2.BACKDROP_OFFSET));
  };

  (0, _react.useEffect)(function () {
    if (!isHalfDarkTheme) setBackDropHeight(0);
    updateValues();
  }, [currentTheme, removeTopPadding]);
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(_colorCarousel.StyledBox, {
    p: containerPadding,
    ref: containerRef,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_COLOR_CAROUSEL,
    id: id
  }, /*#__PURE__*/_react.default.createElement(_themeProvider.GridThemeProvider, {
    gridTheme: {
      container: {
        padding: 15,
        maxWidth: {
          xl: 1140,
          lg: 992,
          md: 768,
          sm: 576,
          xs: 575
        }
      }
    }
  }, /*#__PURE__*/_react.default.createElement(_colorCarousel.WrapperStyled, null, /*#__PURE__*/_react.default.createElement(_headerTitles.HeaderTitles, {
    headline1: headline1,
    headline2: headline2,
    description: description,
    headline1Color: headline1Color,
    headline2Color: headline2Color
  }), colors && /*#__PURE__*/_react.default.createElement(_uiKit.Box, {
    onLoad: updateValues,
    ref: carouselRef
  }, /*#__PURE__*/_react.default.createElement(_carouselUi.default, {
    settings: (0, _const2.settings)(colors.length),
    transparent: true,
    inverse: isInverse,
    arrowStyle: "flat"
  }, colors.map(function (_ref, index) {
    var name = _ref.name,
        fileReference = _ref.fileReference,
        hexValue = _ref.hexValue,
        link = _ref.link,
        description = _ref.description,
        altText = _ref.altText;
    return /*#__PURE__*/_react.default.createElement(_colorCarousel.ItemStyled, {
      href: link,
      key: index
    }, /*#__PURE__*/_react.default.createElement(_colorCircle.default, {
      hexValue: hexValue,
      fileReference: fileReference,
      altText: altText,
      skipLazy: true
    }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      align: "center",
      color: isHalfDarkTheme ? 'gray800' : (0, _helpers.getButtonColorByTheme)(isDarkTheme),
      measure: "xxs",
      uppercase: true,
      letterSpacing: 1.65,
      fontWeight: "bold"
    }, name), description && /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
      align: "center",
      color: "gray800",
      fontSize: 12,
      fontWeight: "light",
      mt: 5,
      mb: 0
    }, description));
  }))), buttons && /*#__PURE__*/_react.default.createElement(_linkButtons.default, {
    buttons: buttons,
    color: isHalfDarkTheme ? 'gray800' : (0, _helpers.getButtonColorByTheme)(isDarkTheme)
  })))));
};

var _default = ColorCarousel;
exports.default = _default;